import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// The base TikTok Pixel script in public/index.html already fires one
// page view on the initial document load. This only needs to fire on
// subsequent client-side route changes.
function PageViewTracker() {
    const location = useLocation();
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (window.ttq) {
            window.ttq.page();
        }
    }, [location.pathname, location.search]);

    return null;
}

export default PageViewTracker;
